<template>
  <v-container>
    <vue-dropzone
      v-if="form.attachment == ''"
      id="drop1"
      ref="dropzone"
      v-on:vdropzone-success="logoUploaded"
      :options="dropOptions"
      class="mb-3"
    ></vue-dropzone>
    <div
      style="text-align: center; position: relative; width: 50%; margin: 0 auto"
      class="mb-3"
      v-else
    >
      <v-btn absolute right top icon flat color="error" @click="removePicture">
        <v-icon>delete</v-icon>
      </v-btn>
    </div>
    <v-card flat style="border-radius: 0">
      <v-card-text class="px-3">
        <h5 style="display: inline-block">Editar Carpeta</h5>
      </v-card-text>
      <v-card-text>
        <v-layout row wrap>
          <v-flex md12 sm12 class="pr-2">
            <v-text-field
              :disabled="loader.disableInput"
              label="ID ATM"
              v-model="form.agent_id"
            ></v-text-field>
          </v-flex>

          <!-- ¡Hola Gregori! Aqui van los datos del agente, aprovecha el loader para que se vea bonito jejeje! pilla que puse un v-if agent_data: null, si quieres pones allí lo que te devuelve la api y renderizas. -->
           <v-layout row wrap v-if="agent_data != null">
            <div
              v-if="loader.agentData"
              style="position: absolute; background: rgba( 255,255,255,0.7 ); width: 100%; height: 100%;"
            >
              <v-progress-circular
                indeterminate
                color="primary"
                :size="50"
                style="position: absolute; top: 50%; left: 50%; transform: translate( -50%, -50% );"
              ></v-progress-circular>
            </div>
            <v-flex md12 sm12 class="pr-2">
              <h5>Datos de ATM</h5>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Nombre" v-model="agent_datas.name" disabled></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Dirección" v-model="agent_datas.direction" disabled></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Distrito" v-model="agent_datas.district" disabled></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Provincia" v-model="agent_datas.province" disabled></v-text-field>
            </v-flex>
          </v-layout>

          <!-- Aqui terminan los datos del agente -->

          <v-flex md12 sm12 class="pr-2">
            <v-select
              :disabled="loader.disableInput"
              label="Documentación"
              v-model="form.type"
              :items="basic.type"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>

          <!-- Fecha de solicitud -->
          <!--<v-menu
            v-model="pickers.date"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :disabled="loader.disableInput"
                :value="formatDate"
                label="Fecha de Emisión"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker locale="es-es" v-model="form.date" @input="pickers.date = false"></v-date-picker>
          </v-menu>-->

          <!-- Fecha de expedición 
          <v-menu
            v-model="pickers.exp_date"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :disabled="loader.disableInput"
                :value="formatExpDate"
                label="Fecha de vencimiento"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker locale="es-es" v-model="form.exp_date" @input="pickers.exp_date = false"></v-date-picker>
          </v-menu>-->

          <!--<v-flex md6 sm12 class="pr-2">
            <v-text-field
              :disabled="loader.disableInput"
              label="Tipo de letrero"
              hint="Solo si es un letrero"
              persistent-hint
            ></v-text-field>
          </v-flex>

          <v-flex md6 sm12>
            <v-text-field
              :disabled="loader.disableInput"
              label="Número de Autorización"
              v-model="form.num"
            ></v-text-field>
          </v-flex>

        <v-flex md6 sm12>
            <v-text-field
              :disabled="loader.disableInput"
              label="Número de Serie"
              v-model="form.serie"
            ></v-text-field>
          </v-flex>
      -->
          <!--<v-flex md12 sm12 class="pr-2">
            <v-select
              :disabled="loader.disableInput"
              v-model="form.status"
              label="Estado actual"
              :items="basic.status"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>-->

          <v-flex md12 sm12>
            <v-text-field
              :disabled="loader.disableInput"
              label="Comentarios"
              v-model="form.observations"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close()" :disabled="loader.saveBtn" color="error">Cerrar</v-btn>
        <v-btn @click="save()" :loading="loader.saveBtn" color="primary">Subir Archivo</v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" bottom right :timeout="2000">
      <v-icon>{{ snackbar.icon }}</v-icon>
      &nbsp;
      {{ snackbar.text }}
      <v-btn flat @click="snackbar.show = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from "moment";
import axios from "@/api/axios/config";
import base_url from "@/api/axios/base_url";
import vueDropzone from "vue2-dropzone";

export default {
  components: {
    vueDropzone
  },
  data() {
    return {
      id: null,
      agent_data: true,
      agent_datas: null,
      loader: {
        agentData: false,
        saveBtn: false,
        disableInput: false
      },
      snackbar: {
        icon: "",
        text: "",
        color: "",
        show: false
      },
      pickers: {
        date: false,
        exp_date: false
      },
      form: {
        agent_id: "",
        num: "",
        serie: "",
        sign_type: "",
        type: "",
        date: "",
        attachment: "",
        exp_date: "",
        status: "",
        observations: ""
      },
      basic: {
        status: [
          { value: "PENDIENTE", text: "Pendiente" },
          { value: "EN CURSO", text: "En curso" },
          { value: "COMPLETADO", text: "Completado" },
          { value: "RECHAZADO", text: "Rechazado" }
        ],
        type: [
          { value: "FOTO FACHADA", text: "Foto Fachada" },
          { value: "LICENCIA LOCAL", text: "Licencia Local" },
          { value: "DNI", text: "DNI" },
          { value: "AUTORIZACION DEL PROPIETARIO", text: "Autorización del Propietario" },
          { value: "FORMATO DJ", text: "Formato DJ" }
        ]
      },
      dropOptions: {
        headers: { Authorization: localStorage.getItem("token") },
        url: base_url.serverURI + "gn/nueva-data-2/attachment",
        maxFilesize: 50, // MB
        maxFiles: 1, //5,
        thumbnailWidth: null, // px
        thumbnailHeight: 240,
        addRemoveLinks: false
      }
    };
  },
  computed: {
    formatDate() {
      return this.form.date ? moment(this.form.date).format("DD/MM/YYYY") : "";
    },
    formatExpDate() {
      return this.form.exp_date ? moment(this.form.exp_date).format("DD/MM/YYYY") : "";
    }
  },
  mounted() {
    this.retrieveData();
  },
  methods: {
    retrieveData() {
      this.loader.disableInput = true;
      this.loader.saveBtn = true;
      axios
        .get("gn/nueva-data-2/" + this.$route.params.id)
        .then(response => {
          if (response.data.status) {
            this.id = response.data.items.id;
            this.form.agent_id = response.data.items.agent_id;
            this.form.num = response.data.items.num;
            this.form.serie = response.data.items.serie;
            this.form.sign_type = response.data.items.sign_type;
            this.form.type = response.data.items.type;
            this.form.date = response.data.items.date;
            this.form.attachment = response.data.items.attachment;
            this.form.exp_date = response.data.items.exp_date;
            this.form.status = response.data.items.status;
            this.form.observations = response.data.items.observations;
            this.agent_datas = response.data.items.agents;
          } else {
            this.$router.push("/GN/agente-archivo-gn/historial-gn");
          }
        })
        .catch(err => {
          this.snackbar = {
            icon: "error",
            text: err,
            color: "success",
            show: true
          };
        })
        .finally(() => {
          this.loader.disableInput = false;
          this.loader.saveBtn = false;
        });
    },
    close() {
      this.$router.push("/GN/agente-archivo-gn/historial-gn");
    },
    removePicture() {
      this.$confirm("¿Realmente quieres eliminar este elemento?").then(res => {
        if (res) {
          this.form.attachment = "";
        }
      });
    },
    logoUploaded(file, response) {
      if (response.status) {
        this.form.attachment = response.path;
        this.snackbar = {
          icon: "check_circle",
          text: "¡Archivo cargado con éxito!",
          color: "success",
          show: true
        };
      } else {
        this.snackbar = {
          icon: "error",
          text: response.error,
          color: "error",
          show: true
        };
      }
    },
    save() {

      if (this.form.attachment != "" && this.form.attachment != null) {
      this.loader.saveBtn = true;
      axios
        .put("gn/nueva-data-2/update/" + this.id, this.form)
        .then(response => {
          if (response.status) {
            this.snackbar = {
              icon: "check_circle",
              text: "¡Cambios guardados con éxito!",
              color: "success",
              show: true
            };

            setTimeout(() => {
              this.$router.push("/GN/agente-archivo-gn/historial-gn");
            }, 2000);
            
          } else {
            this.snackbar = {
              icon: "error",
              text: "Ocurrió un error en el servidor",
              color: "success",
              show: true
            };
          }
        })
        .catch(err => {
          this.snackbar = {
            icon: "error",
            text: err,
            color: "success",
            show: true
          };
        })
        .finally(() => {
          this.loader.saveBtn = false;
        });
    }else{
      this.snackbar = {
              icon: "error",
              text: "Es obligatorio subir un archivo",
              color: "error",
              show: true
            };
    }
  }
  }
};
</script>

<style scoped>
.dragzone {
  border: dashed 2px #bbb;
  border-radius: 10px;
}
.locate-middle {
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translateY(-50%);
  color: #bbb;
}
#drop1 {
  cursor: pointer;
  height: auto;
  padding: 40px;
  border: dashed 2px #bbb;
  color: #bbb;
  font-size: 17px;
  background: transparent;
  border-radius: 10px;
}
#drop1 .dz-preview {
  width: 40%;
}

.dz-image,
.dz-details {
  border-radius: 5px !important;
}
</style>